import AcSwipe from 'ac-components/ac-swiper';
import classnames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
// import { getTrustpilot } from '@services/my-home'
import { Swiper } from 'swiper/types';
import styles from './styles.scss';
const RatingSection: FC = () => {
	const { width } = useResizeObserver();
	const swiperRef = useRef<any>(null);
	const { transData, list, score} = useTranslation('home.rating');
	const htmlRef = useRef<HTMLDivElement>(null);
	const [trustScore, setTrustScore] = useState(score)
	const evaluation = [
		{
			id: 1,
			img: 'https://web-data.zmlearn.com/image/dtBaovsENRGNYe6hwH8BwV/image1.png',
			list: {
				title: "Beyond Impressed!",
				info: "I have been so impressed with the tutoring that my daughter is receiving I have made sure I tell anyone who is willing to listen. Mike has been able to…",
				author: "Patrick Brennan",
			},
			list2: {
				title: "Beyond Impressed!",
				info: "I have been so impressed with the tutoring that my daughter is receiving I have made sure I tell anyone who is willing to listen. Mike has been able to effectively tutor her in grade 11 math because of his style of teaching. The improvement that I have seen in her grades reinforces for me that registering her with this program has been the best investment I have made for my daughter’s future."
			}
		},
		{
			id: 2,
			img: 'https://web-data.zmlearn.com/image/ftMbcuUFEagymZ8BEAP68R/image2.png',
			list: {
				title: "Excellent Methodology of teaching",
				info: "Excellent Methodology of teaching. Simple and easy to understand AirClass is amazing!",
				author: "Tyrone Hogan",
			},
			list2: {
				title: "Excellent Methodology of teaching",
				info: "Excellent Methodology of teaching. Simple and easy to understand AirClass is amazing!"
			}
		},
		{
			id: 3,
			img: 'https://web-data.zmlearn.com/image/bbBLAyCyeHZyVpEF2v1wJ6/image3.png',
			list: {
				title: "Interactive and fun",
				info: "Interactive and fun , the teacher is very nice and cheerful and uses a clear language and gestures. Happy Kids English is really useful!",
				author: "Patrick Bailey",
			},
			list2: {
				title: "Interactive and fun",
				info: "Interactive and fun , the teacher is very nice and cheerful and uses a clear language and gestures. Happy Kids English is really useful!"
			}
		},
		{
			id: 4,
			img: 'https://web-data.zmlearn.com/image/96qyRCpnx18t4vNpWvXCD4/image4.png',
			list: {
				title: "Great",
				info: "I have had a great experience with AirClass every time i was stuck with some new topics. I told my tutor which part that I was confused and then she…",
				author: "Jake Henderson",
			},
			list2: {
				title: "Great",
				info: "I have had a great experience with AirClass every time i was stuck with some new topics. I told my tutor which part that I was confused and then she can help me to solve. MY grade raised!"
			}
		},
		{
			id: 5,
			img: 'https://web-data.zmlearn.com/image/oZU9VBpziovscu6StXZnwT/image5.png',
			list: {
				title: "Great platform and great tutor!",
				info: "Mark is a great teacher who managed to find my writing related weaknesses and helped me overcome them. He offered valuable advice…",
				author: "Carol Arnold",
			},
			list2: {
				title: "Great platform and great tutor!",
				info: "Mark is a great teacher who managed to find my writing related weaknesses and helped me overcome them. He offered valuable advice and guidance for my GCSE Academic exam which led to my success. I really enjoyed our lessons as they were fun and i cannot recommend him highly enough."
			}
		},
		{
			id: 6,
			img: 'https://web-data.zmlearn.com/image/Gixn94ovCER2D2isj1DBM/image6.png',
			list: {
				title: "Would definitely recommend",
				info: "Josephine's teaching style is really clear and precise which made everything much more clear and helped me learn a lot more. The program also helped…",
				author: "Edwin Ramirez",
			},
			list2: {
				title: "Would definitely recommend",
				info: "Josephine's teaching style is really clear and precise which made everything much more clear and helped me learn a lot more. The program also helped me gain confidence to tackle hard problems. I would definitely recommend this to anyone struggling physics."
			}
		},
		{
			id: 7,
			img: 'https://web-data.zmlearn.com/image/dKepY151n3hqeab7yaCBhc/image7.png',
			list: {
				title: "An impressive experience",
				info: "My son is very satisfied with the guidance provided. He has changed from a naughty child to a boy who can concentrate on studying! And rarely…",
				author: "Fannie Chambers",
			},
			list2: {
				title: "An impressive experience",
				info: "My son is very satisfied with the guidance provided. He has changed from a naughty child to a boy who can concentrate on studying! And rarely need me as his mother to supervise his study. We are grateful for the experienced teaching methodology of airclass and the flexibility in arranging tutors."
			}
		},
		{
			id: 8,
			img: 'https://web-data.zmlearn.com/image/2SV8Dra58SRtFteTLEVWvo/image8.png',
			list: {
				title: "It was really helpful studying…",
				info: "I am a student who are studying Italian, and my tutor is so great to help me a lot. Really appreciate.",
				author: "Tyler Davidson",
			},
			list2: {
				title: "It was really helpful studying with professional tutors!",
				info: "I am a student who are studying Italian, and my tutor is so great to help me a lot. Really appreciate."
			}
		},
		{
			id: 9,
			img: 'https://web-data.zmlearn.com/image/kMUabMa3gfT9Lpka85exoL/image9.png',
			list: {
				title: "Superb platform, highly…",
				info: "Amy is a very good maths teacher, she is patient and experienced and she is very prompt in answering questions after the lesson. My daughter always…",
				author: "Lauren Moore",
			},
			list2: {
				title: "Superb platform, highly recommend AirClass",
				info: "Amy is a very good maths teacher, she is patient and experienced and she is very prompt in answering questions after the lesson. My daughter always enjoys her lessons. Very helpful and will no doubt improve her learning. AirClass is very good and the customer service is 5*!"
			}
		},
		{
			id: 10,
			img: 'https://web-data.zmlearn.com/image/kYbBK4V6PyVGVaCkWMFvw7/image10.png',
			list: {
				title: "Zhoe is amazing",
				info: "Zhoe is amazing, the teaching style is professional, and the person is very gentle. She is very patient teaching my child to learn Chinese. My child really…",
				author: "Kieran Cunningham",
			},
			list2: {
				title: "Zhoe is amazing",
				info: "Zhoe is amazing, the teaching style is professional, and the person is very gentle. She is very patient teaching my child to learn Chinese. My child really likes her. At first, my child was shy but became more interactive over time. The teacher gives encouragement to my child so that he continues learning Chinese."
			}
		},
		{
			id: 11,
			img: 'https://web-data.zmlearn.com/image/bhWiXs7StR1inXhLtHCkhQ/image11.png',
			list: {
				title: "Excellent services and support",
				info: "Excellent services and support! Right after I asked for some information via the Facebook Yvonne called me and got the first lesson arranged so…",
				author: "Simon Ball",
			},
			list2: {
				title: "Excellent services and support",
				info: "Excellent services and support! Right after I asked for some information via the Facebook Yvonne called me and got the first lesson arranged so quickly. I was so pleasantly surprised! I thank the whole team for all the support and care they're providing my child, which is helping her to be much more confident in her education. Great job you all!"
			}
		},
		{
			id: 12,
			img: 'https://web-data.zmlearn.com/image/6dufpCuHkjHf2eoN6NRRWR/image12.png',
			list: {
				title: "Great Service",
				info: "I like our consultant Jenny, she never over sale and always think what we need! When we told her that we want to switch a tutor, she is patient and…",
				author: "Irene Rogers",
			},
			list2: {
				title: "Great Service",
				info: "I like our consultant Jenny, she never over sale and always think what we need! When we told her that we want to switch a tutor, she is patient and now my son is satisfied with his lesson! Ben is a great teacher!"
			}
		},
	];
	const itemList = (evaluation as any[]).map((item, index) => {
		return (
			<div className={classnames(styles['ac-home-comment-item'], styles[`ac-home-comment-item-${item.id}`], `ac-home-comment-item-${item.id}`)} key={index}>
				<h1 className={styles['ac-home-comment-item-context']}>
					<div className={styles['img']}>
						<i className={styles['zan']}></i>
						<h2>{item.list.title}</h2>
						<p className={styles['text']}>{item.list.info}</p>
						<div className={styles['isBottom']}>
							<p className={styles['author']}>{item.list.author}</p>
							<i className={styles['star']}></i>
						</div>
					</div>
					<div className={styles['img2']}>
						<h2>{item.list2.title}</h2>
						<p>{item.list2.info}</p>
					</div>
				</h1>
			</div>
		);
	});
	const phoneBetween = width < 768 ? 16 : 24;
	const spaceBetween = width >= 1192 ? 32 : phoneBetween;

	return (
		<section className={styles['ac-home-comment']}>
			<div className={styles['ac-home-comment-container']}>
				<h1>See what other parents say</h1>
				<div className={styles['comment-wrap']}>
					<p>AirClass is trusted by over 500,000+ students</p>
				</div>
				<AcSwipe
					className={classnames(styles['ac-home-comment-banner'], 'ac-home-comment-banner')}
					loop={true}
					spaceBetween={spaceBetween}
					autoplay={{
						delay: 5000,
						disableOnInteraction: false,
					}}
					onSwiper={(swiper: Swiper) => {
						swiperRef.current = swiper;
					}}
					slidesPerView={width >= 1192 ? 3 : 'auto'}
					allowTouchMove={width < 1192}
					pagination={width >= 768 ? {
						clickable: true,
					} : true}>
					{itemList}
				</AcSwipe>
			</div>
		</section>
	);
};

export default RatingSection;
